import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { IonicModule, Platform } from '@ionic/angular';
import { IonImg } from '@ionic/angular/standalone';

@Component({
  selector: 'app-promo',
  templateUrl: './promo.component.html',
  styleUrls: ['./promo.component.scss'],
  standalone: true,
  imports: [IonicModule, RouterModule]
})
export class PromoComponent  implements OnInit {
  platform = inject(Platform)

  constructor() { }

  async ngOnInit() {
    if (this.platform.is('android')) {
      this.openPlayStore();
    } else if (this.platform.is('ios')){
      this.openAppStore();
    }
  }

  async openPlayStore() {
    await Browser.open({url: 'https://play.google.com/store/apps/details?id=com.ioncourt.tracker&hl=en_US&gl=US'})

  }

  async openAppStore() {
    await Browser.open({url: 'https://apps.apple.com/us/app/ioncourt-tennis-match-tracker/id1489506140'})
  }

  async openSocial(social: string) {
    let link: string | undefined;
    if (social === 'linkedin') link = 'https://www.linkedin.com/company/ionsport/';

    if (link) {
      await Browser.open({
        url: link,
      });
    }

  }

}
